<template>
    <v-layout>
        <v-flex>
            <v-card>
                <v-card-title>
                    <h3 class="headline mb-0 admin-header">Users</h3>
                    <v-btn text icon color="grey lighten-1" @click="refresh(pagination)"><v-icon>fas fa-sync</v-icon></v-btn>
                </v-card-title>
                <v-card-text>
                    <v-layout wrap>
                        <span class="subheading"><b>Filters:</b></span>
                        <v-icon v-if="showFilters" @click="showFilters = !showFilters">fal fa-chevron-up</v-icon>
                        <v-icon v-if="!showFilters" @click="showFilters = !showFilters">fal fa-chevron-down</v-icon>
                    </v-layout>
                        <v-form v-model="valid" v-if="showFilters" @submit.prevent>
                    <v-layout wrap>
                        <v-flex xs11>
                            <v-layout wrap>
                                <v-flex xs2 ml-4>
                                    <v-text-field label="Id" v-model="id" :rules="[rules.numeric]"></v-text-field>
                                </v-flex>
                                <v-flex xs2 ml-4>
                                    <v-autocomplete
                                    v-model="orgId"
                                    :items="organizations"
                                    label="Organization"
                                        item-text="text"
                                        item-value="value">
                                    </v-autocomplete>
                                </v-flex>
                                <v-flex xs2 ml-4>
                                    <v-select label="Deleted" v-model="deleted" :items="deletedItems"></v-select>
                                </v-flex>
                                <v-flex xs2 ml-4>
                                    <v-select label="Collection Agent" v-model="collectionAgent" :items="collAgentItems"></v-select>
                                </v-flex>
                                <v-flex xs2 ml-4>
                                    <v-select label="External" v-model="isExternal" :items="externalItems"></v-select>
                                </v-flex>
                                <v-flex xs2 ml-4>
                                    <v-text-field label="Name" v-model="name"></v-text-field>
                                </v-flex>
                                <v-flex xs2 ml-4>
                                    <v-text-field label="Login" v-model="login"></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex xs1>
                            <button onsubmit="false" class="btn btn-primary" @click="applyFilters" :disabled="!valid">Apply</button>
                            <button onsubmit="false" class="btn btn-default" @click="resetFilters">Reset</button>
                        </v-flex>
                    </v-layout>
                        </v-form>
                    <v-layout wrap>
                        <v-flex xs12>
                            <v-data-table
                              :items="users.content"
                              :loading="loading"
                              :headers="headers"
                              :options.sync="pagination"
                              :footer-props="{'items-per-page-options': [5, 10, 15, 20, 50, 100]}"
                              :server-items-length="totalItems" class="elevation-1"
                            >
                              <template v-slot:item.name="{item}">
                                <td>
                                    <router-link v-if="isSUPro" to="" @click.native="editItem(item)">{{item.name}}</router-link>
                                    <span v-else>{{item.name}}</span>
                                </td>
                              </template>
                              <template v-slot:item.updatedDate="{item}">
                                <td>{{formatDateTime(item.updatedDate)}}</td>
                              </template>
                              <template v-slot:item.deleted="{item}">
                                <td>{{item.deleted ? 'yes' : 'no' }}</td>
                              </template>
                              <template v-slot:item.collectionAgent="{item}">
                                <td>{{item.collectionAgent === true ? 'yes' : ( item.collectionAgent === false ? 'no' : '') }}</td>
                              </template>
                              <template v-slot:item.actions="{item}">
                                <td class="actions" v-if="isSUPro">
                                  <v-btn text icon @click="editItem(item)"
                                  style="height: 0px; width: 0px; padding-right:2px;">
                                      <v-icon color="grey lighten-1" style="font-size: 18px;" >fas fa-pencil</v-icon>
                                  </v-btn>
                                  <!-- IMPERSONATION OPTIONS
                                    <v-tooltip bottom v-if="canLaunchModule(item.login)" >
                                      <template v-slot:activator="{on}">
                                        <v-btn text icon @click="launchModule(item, 'assurance')"
                                          v-on="on"
                                          style="height: 0px; width: 0px;"
                                        >
                                          <v-icon color="grey lighten-1" style="font-size: 18px;">show_chart</v-icon>
                                        </v-btn>
                                      </template>
                                      <span>Launch CPM Monitoring</span>
                                    </v-tooltip>
                                    <v-tooltip bottom v-if="canLaunchModule(item.login)" >
                                      <template v-slot:activator="{on}">
                                        <v-btn text icon @click="launchModule(item, 'historical2')"
                                          v-on="on"
                                          style="height: 0px; width: 0px;"
                                        >
                                          <v-icon color="grey lighten-1" style="font-size: 18px;">bar_chart</v-icon>
                                        </v-btn>
                                      </template>
                                      <span>Launch CPM Analytics</span>
                                    </v-tooltip>
                                    <v-tooltip bottom v-if="canLaunchModule(item.login)" >
                                      <template v-slot:activator="{on}">
                                        <v-btn text icon @click="launchModule(item, 'rooms')"
                                          v-on="on"
                                          style="height: 0px; width: 0px;"
                                        >
                                          <v-icon color="grey lighten-1" style="font-size: 18px;">business</v-icon>
                                        </v-btn>
                                      </template>
                                      <span>Launch Workspace Insights</span>
                                    </v-tooltip>
                                  -->
                                </td>
                              </template>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
            <v-dialog v-model="showEditUserDialog" max-width="600px">
                <v-card>
                    <v-card-title>
                    <span class="headline">User</span>
                    </v-card-title>

                    <v-card-text>
                        <v-form v-model="validUser" @submit.prevent>
                        <v-container grid-list-md>
                            <v-layout wrap>
                                <v-flex xs12 class="subheading">
                                   Id: {{editedItem.id}} OrgId: {{editedItem.org.id}} ({{editedItem.org.name}})
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                    <v-text-field v-model="editedItem.name" :rules="[rules.required]" label="Name"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                    <v-text-field v-model="editedItem.login" label="Login"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                    <v-text-field v-model="editedItem.phone" label="Phone"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                    <v-text-field v-model="editedItem.email" label="Email"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                    <v-checkbox v-model="editedItem.deleted" label="Deleted"></v-checkbox>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                    <v-checkbox v-model="editedItem.isExternal" label="External"></v-checkbox>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                    <v-checkbox v-model="editedItem.collectionAgent" label="Collection Agent"></v-checkbox>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                    <v-select v-model="editedItem.authType" :items="authTypes" label="Auth Type"></v-select>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                    <v-checkbox v-model="editedItem.communicationOptIn" label="Communication Opt In"></v-checkbox>
                                </v-flex>
                                <v-flex xs12>
                                    <v-textarea v-model="editedItem.consentJson" label="Consent Json"></v-textarea>
                                </v-flex>
                            </v-layout>
                        </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn text color="blue darken-1" @click.native="close">Cancel</v-btn>
                        <v-btn text color="blue darken-1" :disabled="!validUser" @click.native="save">Save</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-flex>
    </v-layout>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import Utility from './utility'
export default {
    computed: {
        ...mapGetters('user', {
            organizations: 'getOrganizationsTextValue',
            isSU: 'isSU',
            isSUPro: 'isSUPro'
        }),
        ...mapGetters('menus', {
          findRouteTitle: 'findRouteTitle'
        }),
        routeTitle: {
          get() {
            return this.findRouteTitle(this.$route.name) || this.title
          }
        }
    },
    data() {
        return {
            users: {
                "content": [],
                "totalElements": 0
            },
            loading: false,
            search: '',
            pagination : {
                    descending: true,
                    page: 1,
                    rowsPerPage: 10, // -1 for All",
                    itemsPerPage: 10,
                    sortBy: ["updatedDate"]
            },
            totalItems: 0,
            headers: [
                {text: 'Id', align: 'left', sortable: true, value: 'id'},
                {text: 'Org Id', align: 'left', sortable: true, value: 'org.id'},
                {text: 'Org Name', align: 'left', sortable: true, value: 'org.name'},
                {text: 'Name', align: 'left', sortable: true, value: 'name'},
                {text: 'Login', align: 'left', sortable: true, value: 'login'},
                {text: 'Updated Date', align: 'left', sortable: true, value: 'updatedDate'},
                {text: 'External', align: 'left', sortable: true, value: 'isExternal'},
                {text: 'Auth Type', align: 'left', sortable: true, value: 'authType'},
                {text: 'Deleted', align: 'left', sortable: true, value: 'deleted'},
                {text: 'Collection Agent', align: 'left', sortable: true, value: 'collectionAgent'}
            ],
            deleted: null,
            orgId: null,
            name: null,
            login: null,
            collectionAgent: null,
            communicationOptIn: null,
            consentJson: null,
            isExternal: null,
            id: null,
            deletedItems:[
                {text: 'All', value: null},
                {text: 'Deleted only', value: true},
                {text: 'Non-deleted only', value: false}
            ],
            collAgentItems:[
                {text: 'All', value: null},
                {text: 'Collection agents only', value: true},
                {text: 'Non-collection agents only', value: false}
            ],
            externalItems:[
                {text: 'All', value: null},
                {text: 'External only', value: true},
                {text: 'Non-external only', value: false}
            ],
            rules: {
                required: value => !!value || 'Required.',
                numeric: value => !value || Number.isInteger(+value) || 'Invalid format'
            },
            valid: false,
            showFilters: true,
            validUser: false,
            showEditUserDialog: false,
            originalItem: null,
            editedItem: {
                id: -1,
                name: '',
                login: '',
                phone: '',
                email: '',
                deleted: false,
                collectionAgent: false,
                org: {id: '', name: ''},
                isExternal: false,
                authType: '',
                communicationOptIn: null,
                consentJson: null
            },
            defaultItem: {
                id: -1,
                name: '',
                login: '',
                phone: '',
                email: '',
                deleted: false,
                collectionAgent: false,
                org: {id: '', name: ''},
                isExternal: false,
                authType: 'default',
                communicationOptIn: null,
                consentJson: null
            },
            authTypes: [
                {text: 'Default', value: 'default'},
                {text: 'Internal', value: 'internal'},
                {text: 'SAML', value: 'saml'},
                {text: 'OneCloud', value: 'onecloud'}
            ],
        }
    },
    created() {
        if (this.isSUPro) {
            this.headers.push({text: 'Actions', align: 'left', sortable: false, value: 'actions'})
        }
    },
    watch: {
        pagination: {
            async handler () {
                await this.refresh(this.pagination)
            }, deep: true
        }
    },
    methods: {
        async refresh(pagination) {

            const { page, itemsPerPage, sortBy, sortDesc } = pagination

            let sort = ""
            if (sortBy && sortBy.length) {
                sort = sortBy[0] + "," + (sortDesc && sortDesc.length && sortDesc[0] ? 'desc' : 'asc')
            }

            let id = this.id ? +this.id : this.id

            let filter = Utility.buildQueryString(
                ['id', 'name', 'login', 'collection_agent', 'org_id', 'deleted', 'is_external', 'communicationOptIn', 'consentJson'],
                [id, this.name, this.login, this.collectionAgent, this.orgId, this.deleted, this.isExternal, this.communicationOptIn, this.consentJson],
                ['name', 'login'])

            this.loading = true

            this.users = await this.$store.dispatch('crossorg/getUsers',
                {filter, size: itemsPerPage || 10, page: page ? page - 1 : 0, sort})

            this.totalItems = this.users.totalElements

            this.loading = false
        },
        formatDateTime(val) {
            if (!val) {
                return ''
            }
            return moment(val).isValid() ? moment(val).format('MM/DD/YYYY, h:mm:ss a') : val
        },
        async resetFilters() {
            this.deleted = null
            this.orgId = null
            this.name = null
            this.login = null
            this.collectionAgent = null
            this.isExternal = null
            this.id = null
            this.communicationOptIn = null
            this.consentJson = null

            await this.refresh(this.pagination)

        },
        async applyFilters() {
            await this.refresh(this.pagination)
        },
        async editItem (item) {
            this.originalItem = item
            this.editedItem = Object.assign({}, item)
            this.showEditUserDialog = true
        },
        close() {
            this.showEditUserDialog = false
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.originalItem = null
            }, 300)
        },
        async save () {
            await this.$store.dispatch("crossorg/updateUser", {user: this.editedItem,
                                    patchObject: Utility.createPatchObject(this.originalItem, this.editedItem)})
            this.close()

            await this.refresh(this.pagination)
        },
        async launchModule(user, module) {

            let url = await this.$store.dispatch('crossorg/buildModuleURL', {userId: user.id, orgId: user.org.id, login: user.login, module})

          var objActivity = {
            action: 'impersonation',
            appId: 'cpm-admin',
            view: this.$route.name,
            tab: '',
            url: window.location.href,
            source: 'COUserList.vue',
            details: 'impersonating orgId ' + user.org.id + ' userId ' + user.id + ' (' + (user.login) + ') module ' + module,
            data: JSON.stringify({orgId: user.org.id, userId: user.id, login: user.login, module: module})
          };
          await this.$store.dispatch('status/logActivity', objActivity);

          window.open(url)

        },
        canLaunchModule(login) {
            return this.isSUPro || (login.includes('vyoptaadmin') && this.isSU)
        }
    }
}
</script>
